// @flow
import type { Node } from 'react';
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import { FormattedMessage } from 'react-intl';
import Loading from '../../../../../elements/Loading/Loading';
import Modal from '../../../../../elements/Modal/Modal';

import commonStyle from '../../../components/OrderCommon.scss';
import boxStyle from '../../../../../assets/styles/box.scss';
import icons from '../../../../../assets/styles/icons.scss';
import style from './Feedback.scss';
import thumbUp from '../../../../../assets/img/YOGI-SAD.png';
import buttonStyle from '../../../../../assets/styles/button.scss';
import inputStyle from '../../../../../assets/styles/input.scss';
import fblogo from '../../../../../assets/img/new-order/checkout-success-step/facebook.png';
import glogo from '../../../../../assets/img/new-order/checkout-success-step/google.png';
import yogiLeg from '../../../../../assets/img/YOGI-QEMPO2.png';

import type { Order } from '../../../../../entities';

type Props = {
  +buildStatusBoard: () => Node;
  +buildProducts: () => Node;
  +buildSummary: () => Node;
  +buildTravelerInfo: () => Node;
  +postFeedback: (orderId: string, isGood: boolean, feedback?: string) => void;
  +order: Order;
  +isPostingFeedback: boolean;
};

type State = {
  // feedbackModalVisible: boolean;
  feedback: {
    value: string;
  };
  // type?: string;
};

export default class Feedback extends Component<Props, State> {

  state = {
    // feedbackModalVisible: false,
    feedback: {
      value: '',
    },
    // type: '',
  };

  componentDidUpdate(prevProps: Props) {
    const { isPostingFeedback } = this.props;
    // const { feedbackModalVisible } = this.state;
    /*if (!prevProps.isPostingFeedback && isPostingFeedback && feedbackModalVisible) {
      this.handleCloseModal();
    }*/
  }

  handleChange = (e: Event) => {
    if (e.target instanceof HTMLTextAreaElement) {
      const { name, value } = e.target;
      this.setState({ [name]: { value } });
    }
  };

  /*handleOpenModal = (type: string) => {
    this.setState({ feedbackModalVisible: true, type });
  };

  handleCloseModal = () => {
    this.setState({ feedbackModalVisible: false });
  };*/

  /*handleSendFeedback = () => {
    const { postFeedback, order } = this.props;
    const { type, feedback } = this.state;
    if (type === 'positive') {
      postFeedback(order.id, true, feedback.value);
    } else {
      postFeedback(order.id, false, feedback.value);
    }
  };*/

  handleClickSharedDialog = () => {
    if (!(window: any).FB) return Promise.reject(new Error('FB is not defined'));
    (window: any).FB.ui({
      method: 'share',
      href: 'https://www.qempo.com',
    }, (response) => console.log(response));
  };

  render() {
    const {
      buildStatusBoard, order, buildProducts, buildSummary, buildTravelerInfo, isPostingFeedback, postFeedback,
    } = this.props;
    // const { feedbackModalVisible, feedback, type } = this.state;
    return (
      <Fragment>
        <main className={commonStyle.mainWrap}>
          <section className={classNames(commonStyle.wrap, commonStyle.leftWrap)}>
            {buildStatusBoard()}
            <section className={classNames(boxStyle.box, style.box)}>
              {isPostingFeedback && <Loading className={style.loading}
                                             type="circle"/>}
              <section className={classNames({ [style.disabled]: isPostingFeedback })}>
                <FormattedMessage id="order.purchase.feedback.question">{
                  txt => <h2 className={classNames(boxStyle.boxTitle)}>{txt}</h2>
                }</FormattedMessage>
                <section className={style.feedback}>
                  {/*<img className={classNames(style.negative, { [style.grey]: false })}
                       src={thumbUp}
                       alt="thumbDown"
                       onClick={() => postFeedback(order.id, false)}/>
                  <img className={classNames(style.positive, { [style.grey]: false })}
                       src={thumbUp}
                       alt="thumbUp"
                       onClick={() => postFeedback(order.id, true)}/>*/}

                  <div className={classNames(style.thumbWrap, style.bad,
                    { [style.selected]: typeof order.travelerReview === 'boolean' },
                    { [style.active]: typeof order.travelerReview === 'boolean' && !order.travelerReview },
                    { [style.disabled]: typeof order.travelerReview === 'boolean' && order.travelerReview })}
                       onClick={() => postFeedback(order.id, false)}>
                    <i className={icons.iconThumbUpLight}/>
                  </div>

                  <div className={classNames(style.thumbWrap, style.good,
                    { [style.selected]: typeof order.travelerReview === 'boolean' },
                    { [style.active]: typeof order.travelerReview === 'boolean' && order.travelerReview },
                    { [style.disabled]: typeof order.travelerReview === 'boolean' && !order.travelerReview })}
                       onClick={() => postFeedback(order.id, true)}>
                    <i className={icons.iconThumbUpLight}/>
                  </div>
                </section>
                {/*<FormattedMessage id="order.purchase.feedback.positive.text">{
                  txt => <p>{txt}</p>
                }</FormattedMessage>
                <FormattedMessage id="order.purchase.feedback.negative.text.first">{
                  txt => <p>{txt}</p>
                }</FormattedMessage>
                <FormattedMessage id="order.purchase.feedback.negative.text.second">{
                  txt => <p>{txt}</p>
                }</FormattedMessage>*/}
              </section>
            </section>
            {/*<section className={classNames(boxStyle.box, style.box)}>
              <img src={yogiLeg}
                   className={style.yogiPaw}
                   alt="Qempo"/>
              <FormattedMessage id="order.purchase.feedback.text.first">{
                txt => <p>{txt}</p>
              }</FormattedMessage>
              <FormattedMessage id="order.purchase.feedback.text.second">{
                txt => <p>{txt}</p>
              }</FormattedMessage>
            </section>*/}
            <section>
              <article onClick={this.handleClickSharedDialog} className={style.socialBlock}>
                <FormattedMessage id="newOrder.checkoutSuccess.box.social.title.sharing">{
                  txt => <p>{txt}</p>
                }</FormattedMessage>
                <img src={fblogo} alt="fblogo"/>
              </article>
              <a target="_blank"
                 href="https://www.google.com/search?q=Qempo#lrd=0x9105c88b533d38cd:0x85771c5ac4165f4b,3"
                 className={style.socialBlock}>
                <FormattedMessage id="newOrder.checkoutSuccess.box.social.title.commentary">{
                  txt => <p>{txt}</p>
                }</FormattedMessage>
                <img src={glogo} alt="goologo"/>
              </a>
            </section>
            {buildProducts()}
          </section>
          <section className={classNames(commonStyle.wrap, commonStyle.rightWrap)}>
            {buildTravelerInfo()}
            {buildSummary()}
          </section>
        </main>
        {/*<Modal open={feedbackModalVisible}
               big
               handleClose={this.handleCloseModal.bind(this)}>
          <section className={style.feedbackModal}>
            {type === 'positive' ?
              <FormattedMessage id="order.purchase.feedback.modal.positive.title">{
                txt => <p>{txt}</p>
              }</FormattedMessage> :
              <FormattedMessage id="order.purchase.feedback.modal.negative.title">{
                txt => <p>{txt}</p>
              }</FormattedMessage>}
            <FormattedMessage id="order.purchase.feedback.modal.subtitle">{
              txt => <span>{txt}</span>
            }</FormattedMessage>
            <textarea name="feedback"
                      onChange={this.handleChange}
                      value={feedback.value}
                      className={classNames(inputStyle.input, {
                        [inputStyle.lightBlue]: !!feedback.value
                      })}/>
            <FormattedMessage id="order.purchase.feedback.modal.button.sent">{
              txt => <button className={classNames(buttonStyle.btn, buttonStyle.lightBlue)}
                             onClick={this.handleSendFeedback}>{txt}</button>
            }</FormattedMessage>
            <FormattedMessage id="order.purchase.feedback.modal.button.close">{
              txt => <button className={classNames(buttonStyle.btn, buttonStyle.darkGrey)}
                             onClick={this.handleCloseModal}>{txt}</button>
            }</FormattedMessage>
          </section>
        </Modal>*/}
      </Fragment>
    );
  }
}

Feedback.propTypes = {
  buildStatusBoard: PropTypes.func.isRequired,
  buildProducts: PropTypes.func.isRequired,
  buildSummary: PropTypes.func.isRequired,
  buildTravelerInfo: PropTypes.func.isRequired,
  postFeedback: PropTypes.func.isRequired,
  order: PropTypes.object.isRequired,
  isPostingFeedback: PropTypes.bool,
};



// WEBPACK FOOTER //
// ./src/modules/order/Purchase/feedback/components/Feedback.jsx